import { useTranslation } from "react-i18next";
import {
  ACTIONS,
  AuthRoutes,
  USERTYPES,
  TOAST_TYPE,
} from "../../constants/Constants";
import { AdminSchema } from "../../Schemas/AdminSchema";
import {
  fetchEditUserData,
  getSignatureImage,
  newUserData,
  viewUser,
} from "../../service/UserService";

import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile,
} from "react-device-detect";

import {
  data,
  addTabStatusInitialValue,
  editTabStatusInitialValue,
} from "./helpers/InitialData";
import CustomSpinner from "../../components/CustomSpinner";
import { submitUserData } from "./helpers/SubmitUserData";
import SelectFirmDialog from "./components/SelectFirmDialog";
import { useFormik } from "formik";
import React, { useCallback, useEffect, useState, useContext } from "react";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import CustomBreadCrumb from "../../components/CustomBreadCrumb";
import {
  addEditAdminBreadCrumbItems,
  addEditFirmDoctorBreadCrumbItems,
  addEditFirmTechnicianBreadCrumbItems,
  addEditRadiologistBreadCrumbItems,
  addEditSupervisorBreadCrumbItems,
  addEditTypistBreadCrumbItems,
} from "../../constants/BreadCrumbOptions";

import CustomTab from "../../components/TabContainer/CustomTab";
import UserDetailsSection from "./components/UserDetailsSetion/UserDetailsSection";
import ContactDetails from "../AccountAndSettings/ContactDetails/ContactDetails";
import SettingsSection from "./components/SettingSection/SettingsSection";
import userContext from "../../context/users/UserContext";
import FirmAccessSection from "./components/FirmAccessSection/FirmAccessSection";
import TabContainer from "../../components/TabContainer/TabContainer";
import loaderContext from "../../context/loader/LoaderContext";
import toastContext from "../../context/toast/ToastContext";
import DialogBox from "../../components/Modal/DialogBox";
import { DefaultButton, PrimaryButton } from "@fluentui/react";
import AssignmentPreferences from "./components/ModalitySection/AssignmentPreferences";
import { constantStyleForSelect } from "../../components/CustomSelect";
import ContactDetailsSection from "./components/ContactDetailsSection/ContactDetailsSection";
import SupervisorAssignmentPreferences from "./components/ModalitySection/SupervisorAssignmentPreferences";
import ModalMain from "../../components/Modal/ModalMain";
import ModalHeader from "../../components/Modal/ModalHeader";
import ModalFooter from "../../components/Modal/ModalFooter";
import { getEnv } from '../../helpers/EnvHelper';

const MyAddUpdateUser = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  const [fetchDataToggle, setFetchDataToggle] = useState(false);
  const [userType, setUserType] = useState(
    props.action == ACTIONS.ADD ? props.userType : ""
  );
  const [firmList, setFirmList] = useState([]);
  const [checkAllFirm, setCheckAllFirm] = useState(false);
  const [checkSecurityFlag, setCheckSecurityFlag] = useState(false);
  const [checkFirm, setCheckFirm] = useState([]);
  const [selectedModalityForFirm, setSelectedModalityForFirm] = useState([]);
  const [checkFirmNew, setCheckFirmNew] = useState(new Map());
  const [modalityList, setModalityList] = useState([]);
  const [searchParams] = useSearchParams();
  const [userData, setUserData] = useState({});
  const [t, i18n] = useTranslation();
  const [expertRadiologist, setExpertRadiologist] = useState(false);
  const [breadCrumbItems, setBreadCrumBItems] = useState([]);
  const [radiologistSignatureImage, setRadiologistSignatureImage] =
    useState("");
  const [showCheckFirmDialog, setShowCheckFirmDialog] = useState(false);
  const [showSelectModalityDialog, setShowSelectModalityDialog] =
    useState(false);
  const [submitClicked, setSubmitClick] = useState(false);
  const [selectedTab, setselectedTab] = useState("1");
  const [showTabTwo, setShowTabTwo] = useState(false);
  const [showTabThree, setShowTabThree] = useState(false);
  const [showTabFour, setShowTabFour] = useState(false);
  const [showTabFive, setShowTabFive] = useState(false);
  const [totalTabs, setTotalTabs] = useState(1);
  const { ref, setLoaderRunning } = useContext(loaderContext);
  const { showToastv2 } = useContext(toastContext);
  const [tabStatusInitialValue, setTabStatusInitialValue] = useState(
    props.action === ACTIONS.ADD
      ? addTabStatusInitialValue
      : editTabStatusInitialValue
  );
  const { roles, authenticated, loadByUsername, username, firmId, checkForUserAccess } =
    useContext(userContext);
  const [nextClicked, setNextClicked] = useState(false);
  const [customMobileError, setCustomMobileError] = useState(null);
  const [firmName, setFirmName] = useState("");
  const [noSelectionErrorMessage, setNoSelectionErrorMessage] = useState("");
  const [selectedModalityWithSubModality, setSelectedModalityWithSubModality] =
    useState([]);
  const [modalityWithSubModalityList, setModalityWithSubModalityList] =
    useState([]);
  const [
    selectedModalitySubmodalityNames,
    setSelectedModalitySubmodalityNames,
  ] = useState([]);
  const [action, setAction] = useState(props.action);
  
  const [selectedPediatricModalityId, setSelectedPediatricModalityId] = useState([]);
  
  const [pediatricSpecialist, setPediatricSpecialist] = useState(false);
  const [isRadiologistSignatureImageDeleted, setIsRadiologistSignatureImageDeleted] = useState(false);
  const [radiologistImageFileName, setRadiologistImageFileName] = useState("No File Chosen");
  const [technicianContactList, setTechnicianContactList] = useState([]);
  const [updateActiveTab, setUpdateActiveTab] = useState(null);
  const [whatsappParentEnabled, setWhatsappParentEnabled] = useState(false);
  const [emailParentEnabled, setEmailParentEnabled] = useState(false);
  const [showExportWarning, setShowExportWarning] = useState(false);


  const isInvalidWhatsAppValue = (value) => {
    if (!value) return true;

    // Remove "+"
    const digits = value.replace("+", "");

    // country code only (or too short) is invalid
    return digits.length <= 6;
  };


  let firmID =
    searchParams.get("firmId") != null ? searchParams.get("firmId") : firmId;

  const handleClearRadiologistSignatureImage = () => {
      
    console.log("In handleClearRadiologistSignatureImage");
    setIsRadiologistSignatureImageDeleted(true);
    setRadiologistImageFileName("No File Chosen");
    setValues({
      ...values,
      signatureDto: {
        ...values.signatureDto,
        isSignatureImageDeleted: 1,
        signatureImageUrl: null
        
      }
    })
  }
  useEffect(() => {

    console.log(action)

    const forType = searchParams.get("for");
    if (forType === null || forType === "undefined") return;
    let enterprise =
      getEnv("REACT_APP_ENTERPRISE_PLATFORM") == "true" ||
      getEnv("REACT_APP_ENTERPRISE_PLATFORM") == true
        ? true
        : false;
    if (userType === USERTYPES.FIRMADMIN) {
      setBreadCrumBItems([
        {
          text: enterprise ? t("hospital.hospitals") : t("hospital.firms"),
          key: "hospital",
          onClick: () => navigate(AuthRoutes.FIRMLIST),
        },
        {
          text: enterprise
            ? t("hospital.hospital-details")
            : t("hospital.firm-details"),
          key: "hospital-details",
          // href: window.history.go(-1)
          onClick: () =>
          action === ACTIONS.EDIT
              ? window.history.go(-2)
              : window.history.go(-1),
        },
        {
          text: `${
            action === ACTIONS.ADD
              ? t("admin.add-firm-admin")
              : action === ACTIONS.EDIT
              ? t("admin.edit-firm-admin")
              : "View Firm Admin"
          }`,
          key: "add-edit-firmadmin",
        },
      ]);
    } else if (userType === USERTYPES.SUPERVISOR) {
      setBreadCrumBItems([
        {
          text: enterprise ? t("hospital.hospitals") : t("hospital.firms"),
          key: "hospital",
          onClick: () => navigate(AuthRoutes.FIRMLIST),
        },
        {
          text: enterprise
            ? t("hospital.hospital-details")
            : t("hospital.firm-details"),
          key: "hospital-details",
          // href: window.history.go(-1)
          onClick: () =>
          action === ACTIONS.EDIT
              ? window.history.go(-2)
              : window.history.go(-1),
        },
        {
          text: `${
            action === ACTIONS.ADD
              ? t("supervisor.add-supervisor")
              : action === ACTIONS.EDIT
              ? t("supervisor.edit-supervisor")
              : "View Supervisor"
          }`,
          key: "add-edit-supervisor",
        },
      ]);
    } else if (userType === USERTYPES.FIRMTECHNICIAN) {
      console.log(action === ACTIONS.EDIT)
      setBreadCrumBItems([
        {
          text: enterprise
            ? t("hospital.hospitals")
            : roles[0] === USERTYPES.ADMIN
            ? t("hospital.firms")
            : t("hospital.clients"),
          key: "hospital",
          onClick: () =>
            roles[0] === USERTYPES.ADMIN
              ? navigate(AuthRoutes.FIRMLIST)
              : navigate(AuthRoutes.CLIENTLIST),
        },
        {
          text: enterprise
            ? t("hospital.hospital-details")
            : roles[0] === USERTYPES.ADMIN
            ? t("hospital.firm-details")
            : t("hospital.client-details"),
          key: "hospital-details",
          // href: window.history.go(-1)
          onClick: () =>
          action === ACTIONS.EDIT
              ? window.history.go(-2)
              : window.history.go(-1),
        },
        {
          text: `${
            action === ACTIONS.ADD
              ? roles[0] === USERTYPES.ADMIN
                ? t("firmtechnician.add-firmtechnician")
                : t("firmtechnician.add-clienttechnician")
              : action === ACTIONS.EDIT
              ? roles[0] === USERTYPES.ADMIN
                ? t("firmtechnician.edit-firmtechnician")
                : t("firmtechnician.edit-clienttechnician")
              : "View Firm Technician"
          }`,
          key: "add-edit-firmtechnician",
        },
      ]);
    } else if (userType === USERTYPES.FIRMDOCTOR) {
      setBreadCrumBItems([
        {
          text: enterprise
            ? t("hospital.hospitals")
            : roles[0] === USERTYPES.ADMIN
            ? t("hospital.firms")
            : t("hospital.clients"),
          key: "hospital",
          onClick: () =>
            roles[0] === USERTYPES.ADMIN
              ? navigate(AuthRoutes.FIRMLIST)
              : navigate(AuthRoutes.CLIENTLIST),
        },
        {
          text: enterprise
            ? t("hospital.hospital-details")
            : roles[0] === USERTYPES.ADMIN
            ? t("hospital.firm-details")
            : t("hospital.client-details"),
          key: "hospital-details",
          // href: window.history.go(-1)
          onClick: () =>
          action === ACTIONS.EDIT
              ? window.history.go(-2)
              : window.history.go(-1),
        },
        {
          text: `${
            action === ACTIONS.ADD
              ? roles[0] === USERTYPES.ADMIN
                ? t("firmdoctor.add-firmdoctor")
                : t("firmdoctor.add-clientdoctor")
              : action === ACTIONS.EDIT
              ? roles[0] === USERTYPES.ADMIN
                ? t("firmdoctor.edit-firmdoctor")
                : t("firmdoctor.edit-clientdoctor")
              : "View Firm Doctor"
          }`,
          key: "add-edit-firmtechnician",
        },
      ]);
    } else if (userType === USERTYPES.TYPIST) {
      setBreadCrumBItems([
        {
          text: enterprise
            ? t("hospital.hospitals")
            : roles[0] === USERTYPES.ADMIN
            ? t("hospital.firms")
            : t("hospital.clients"),
          key: "hospital",
          onClick: () =>
            roles[0] === USERTYPES.ADMIN
              ? navigate(AuthRoutes.FIRMLIST)
              : navigate(AuthRoutes.CLIENTLIST),
        },
        {
          text: enterprise
            ? t("hospital.hospital-details")
            : roles[0] === USERTYPES.ADMIN
            ? t("hospital.firm-details")
            : t("hospital.client-details"),
          key: "hospital-details",
          // href: window.history.go(-1)
          onClick: () =>
          action === ACTIONS.EDIT
              ? window.history.go(-2)
              : window.history.go(-1),
        },
        {
          text: `${
            action === ACTIONS.ADD
              ? t("typist.add-typist")
              : action === ACTIONS.EDIT
              ? t("typist.edit-typist")
              : t("typist.view-typist")
          }`,
          key: "add-edit-typist",
        },
      ]);
    }
  }, [userType, action]);

  useEffect(() => {
    if (!authenticated) {
      loadByUsername();
    }
    if (action === ACTIONS.ADD) {
      getNewUserData();
    } else if (action === ACTIONS.EDIT || action === ACTIONS.VIEW) {
      getEditUserData();
    }
  }, [fetchDataToggle, action]);

  useEffect(() => {
    if (userType != "") {
      console.log("INSIDE USERTYPE CHECK");
      if (
        searchParams.get("for") === null ||
        searchParams.get("for") === undefined
      ) {
        console.log("INSIDE FOR CHECK");
        console.log("GETTING BREADCRUMB");
        getBreadCrumbItems();
      }
      handleTabs();
    }
  }, [userType, roles[0], fetchDataToggle]);

  const fetchImage = async (imageName) => {
    console.log(imageName);
    let response = await getSignatureImage(imageName);
    let base64Flag = "data:image/jpeg;base64,";
    if (response.status === 200) {
      setRadiologistSignatureImage(base64Flag + response.data.data);
    }
  };


  const getBreadCrumbItems = (item) => {
    if (userType === USERTYPES.ADMIN || userType === USERTYPES.FIRMADMIN) {
      setBreadCrumBItems(
        addEditAdminBreadCrumbItems(
          item == undefined || item == null ? props : item,
          userType,
          t,
          searchParams.get("firmId")
        )
      );
    } else if (userType === USERTYPES.SUPERVISOR) {
      setBreadCrumBItems(
        addEditSupervisorBreadCrumbItems(
          item == undefined || item == null ? props : item,
          t,
          searchParams.get("firmId")
        )
      );
    } else if (userType === USERTYPES.FIRMTECHNICIAN) {
      setBreadCrumBItems(
        addEditFirmTechnicianBreadCrumbItems(
          item == undefined || item == null ? props : item,
          t,
          searchParams.get("firmId")
        )
      );
    } else if (userType === USERTYPES.FIRMDOCTOR) {
      setBreadCrumBItems(
        addEditFirmDoctorBreadCrumbItems(
          item == undefined || item == null ? props : item,
          t,
          searchParams.get("firmId")
        )
      );
    } else if (userType === USERTYPES.RADIOLOGIST) {
      setBreadCrumBItems(
        addEditRadiologistBreadCrumbItems(
          item == undefined || item == null ? props : item,
          roles[0],
          t
        )
      );
    }else if (userType === USERTYPES.TYPIST) {
      setBreadCrumBItems(
        addEditTypistBreadCrumbItems(
          item == undefined || item == null ? props : item,
          t
        )
      );
    }
  };

  const handleTabs = () => {
    if (userType == USERTYPES.ADMIN || userType == USERTYPES.FIRMADMIN) {
      setShowTabTwo(true);
      setShowTabThree(false);
      setShowTabFour(false);
      setShowTabFive(true);
      setTotalTabs(3);
    }
    if (userType == USERTYPES.SUPERVISOR) {
      setShowTabTwo(true);
      setShowTabThree(true);
      setShowTabFour(true);
      setTotalTabs(3);
    }
    if (userType == USERTYPES.RADIOLOGIST) {
      setShowTabTwo(true);
      setShowTabFour(true);
      if (roles[0] == USERTYPES.FIRMADMIN) {
        setShowTabThree(true);
        setTotalTabs(4);
      }
      if (roles[0] == USERTYPES.ADMIN) {
        setShowTabThree(false);
        setTotalTabs(3);
      }
    }
    if (
      userType == USERTYPES.FIRMDOCTOR ||
      userType == USERTYPES.FIRMTECHNICIAN
    ) {
      setShowTabThree(true);
      setShowTabFour(false);
      // if (props.action == ACTIONS.ADD) {
      //   setShowTabTwo(false);
      //   setShowTabFive(true);
      //   setTotalTabs(3);
      // } else {
        setShowTabTwo(true);
        setShowTabFive(true);
        setTotalTabs(4);
      // }
    }
    if(userType == USERTYPES.TYPIST){
      setShowTabTwo(true);
    }
  };

  const getNewUserData = async () => {
    try {
      setLoaderRunning(true);
      ref.current.continuousStart();
      const response = await newUserData(props.userType, firmID);
      if (response.status === 200 && response.data.result === "SUCCESS") {
        console.log(response);
        setTechnicianContactList(response.data.data.user.technicianContactList);
        setFirmName(
          response.data.data.user.userFirmDto != undefined
            ? response.data.data.user.userFirmDto.name
            : ""
        );
        setFirmList(response.data.data.firmList);
        setUserData(response.data.data);
        console.log("User data in new user : ", userData);
        // setRadiologistImageFileName(response?.data?.data?.user?.signatureDto.signatureImageUrl)
        setModalityList(response.data.data.modalityList);
        setSelectedModalityForFirm(
          response.data.data.modalityList.map((mod) => mod.id)
        );
        setModalityWithSubModalityList(
          response.data.data.modalityWithSubModalityList
        );
        setWhatsappParentEnabled(!!response.data.data.whatsappParentEnabled);
        setEmailParentEnabled(!!response.data.data.emailParentEnabled);
        setLoaderRunning(false);
        ref.current.complete();
        //setValues(data(props, checkFirm, userData, userType))
      } else {
        setLoaderRunning(false);
        ref.current.complete();
      }
    } catch (e) {
      setLoaderRunning(false);
      ref.current.complete();
    }
  };

  const preSelectedModalityWithSubModality = (selectedModalties) => {
    console.log("selectedModalties----", selectedModalties);
    let list1 = [];
    let list2 = [];
    selectedModalties.map((modality, index) => {
      list1.push({
        modalityId: modality.modalityId,
        subModalities: modality.subModalities.map((sm) => sm.id),
      });
      list2.push({
        modalityId: modality.modalityId,
        modalityName: modality.modalityName,
        subModalities: modality.subModalities,
      });
    });
    console.log("list1---", list1);
    setSelectedModalityWithSubModality(list1);
    setSelectedModalitySubmodalityNames(list2);
  };

  const getEditUserData = async () => {
    setLoaderRunning(true);
    let id =
      searchParams.get("id") == null
        ? searchParams.get("providerId")
        : searchParams.get("id");
    const response = await fetchEditUserData(id);
    if (response.status === 200 && response.data.result === "SUCCESS") {
      console.log(response);
      setTechnicianContactList(response.data.data.user.technicianContactList);
      setFirmName(
        response.data.data.user.userFirmDto != undefined
          ? response.data.data.user.userFirmDto.name
          : ""
      );
      setUserData(response.data.data);
      console.log("User data in edit user : ", userData);
      setRadiologistImageFileName(response.data.data.user.signatureDto.signatureImageUrl ? response.data.data.user.signatureDto.signatureImageUrl : "No File Chosen")
      setFirmList(response.data.data.firmList);
      setCheckFirm(response.data.data.firmchklist);
      setCheckSecurityFlag(response.data.data.strictCyberSecurity);
      if (response.data.data.user.selectedModalityForFirm != undefined) {
        setSelectedModalityForFirm(
          response.data.data.user.selectedModalityForFirm.map(Number)
        );
      }
      setCheckFirmNew(new Map())
      if (response.data.data.firmchklistNew != undefined) {
        var firmchklist = response.data.data.firmchklistNew;
        if (response.data.data.editRequestForRole == USERTYPES.SUPERVISOR) {
          firmchklist = firmchklist.filter((firm) => firm.firmId != firmID);
        }
        firmchklist.map((firm) => {
          setCheckFirmNew((prevMap) => {
            const nextMap = new Map(prevMap);
            nextMap.set(parseInt(firm.firmId), firm.modalities.map(Number));
            return nextMap;
          });
        });
      }
      setModalityList(response.data.data.modalityList);
      setModalityWithSubModalityList(
        response.data.data.modalityWithSubModalityList
      );
      preSelectedModalityWithSubModality(
        response.data.data?.modalityWithSubModalityPreferences == null
          ? []
          : response.data.data.modalityWithSubModalityPreferences
      );
      if (
        response.data.data.editRequestForRole === USERTYPES.RADIOLOGIST &&
        response.data.data.user.signatureDto.signatureImageUrl != "" &&
        response.data.data.user.signatureDto.signatureImageUrl != null
      ) {
        fetchImage(response.data.data.user.signatureDto.signatureImageUrl);
      }
      setUserType(response.data.data.editRequestForRole);
      setLoaderRunning(false);
      ref.current.complete();
      //setValues(data(props, checkFirm, userData, userType))
      setInitialErrors(true);
      setTabStatusInitialValue(() => {
        const newStatus = { ...tabStatusInitialValue };
        newStatus.tab1Status = { value: "Completed", color: "green" };
        return newStatus;
      });
      setWhatsappParentEnabled(!!response.data.data.whatsappParentEnabled);
      setEmailParentEnabled(!!response.data.data.emailParentEnabled);
    }
  };

  //INITIAL DATA
  // const initialData = data(props, [], userData, userType, whatsappParentEnabled, emailParentEnabled);

  const initialData = {
    ...data(props, [], userData, userType, whatsappParentEnabled, emailParentEnabled),
    checkSecurityFlag: checkSecurityFlag
  };

  console.log("Initial Data : ", initialData);

  const handleShowFileError = (errors) => {
    console.log("--- Error ----",errors);
    errors.map((error)=>{
        switch(true){
          case error.fieldName == "signatureFile":
            showToastv2(TOAST_TYPE.ERROR, error.defaultMessage);
            break;
          default:
            break;
        }
    })
  }

  const {
    dirty,
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setValues,
    setFieldValue,
    validateForm,
    submitCount,
  } = useFormik({
    initialValues: initialData,
    validationSchema: AdminSchema,
    validate: useCallback((values) => {
      const errors = {};
      if (userType === USERTYPES.TYPIST && !values.showAllStudy && !values.showAddStudy) {
        errors.showAllStudy = "At least one of Show All Studies or Add Study must be selected.";
      }
      if (userType === USERTYPES.TYPIST && values.showAllStudy && (!values.connectedRadiologistIds || values.connectedRadiologistIds.length === 0)) {
        errors.connectedRadiologistIds = "At least one radiologist must be selected.";
      }
      return errors;
    }, [userType]),
    enableReinitialize: true,
    //validateOnChange: true,

    onSubmit: async (values, actions) => {
      if (submitClicked == true) {
        if ((values.mobile == null ||  values.mobile == "") ||  customMobileError != null && customMobileError != "") {
          setTabStatusInitialValue(() => {
            const newStatus = { ...tabStatusInitialValue };
            newStatus.tab1Status = { value: "Info", color: "red" };
            return newStatus;
          });
          return; 
        }
        setLoaderRunning(true);
        ref.current.continuousStart();
        console.log("I am here in submit");
        console.log(values);
        let data = [];
        for (let [key, value] of checkFirmNew) {
          data.push({
            firmId: key,
            modalities: value,
          });
        }

        // const valuesWithTechnicianContactList = {
        //   ...values,
        //   technicianContactList: [
        //     ...values.technicianContactList.map((contact) => ({
        //       name: contact.name,
        //       mobile: contact.mobile,
        //       isPrimaryContact: contact.isPrimaryContact,
        //     })),
        //   ],
        // };
        // console.log("valuesWithTechnicianContactList : ", valuesWithTechnicianContactList);
        
        try{const response = await submitUserData(
          props,
          values,
          data,
          searchParams.get("firmId"),
          firmList,
          userData,
          userType,
          selectedModalityForFirm,
          selectedModalityWithSubModality,
          checkAllFirm
        );
        console.log(response);
        if (response.status === 200 && response.data.result === "SUCCESS") {
          window.location.assign(response.data.data.viewName.substring(9));
          setFetchDataToggle(!fetchDataToggle);
          setLoaderRunning(false);
          ref.current.complete();
          showToastv2(
            TOAST_TYPE.SUCCESS,
            action === ACTIONS.ADD
              ? "User created successfully"
              : "User updated successfully"
          );
        } else {
          setLoaderRunning(false);
          console.log("error",response);
          if(response?.status === 429){
            showToastv2(TOAST_TYPE.ERROR, response?.data?.message);
            return;
          }
          if(response.status === 400){
            ref.current.complete();
            showToastv2(
              TOAST_TYPE.ERROR,response?.data?.message
            );
            return;
          }
          response.data.data.forEach((error) => {
            actions.setFieldError(error.fieldName, error.defaultMessage);
            if (
              error.fieldName == "username" ||
              error.fieldName == "email" ||
              error.fieldName == "lastName" ||
              error.fieldName == "firstName" ||
              error.fieldName == "password"
            ) {
              setUpdateActiveTab("1");
              setTabStatusInitialValue(() => {
                const newStatus = { ...tabStatusInitialValue };
                newStatus.tab1Status = { value: "Info", color: "red" };
                return newStatus;
              });
            }
            else if (error.fieldName == "capacity" || error.fieldName == "signatureText") {
              setTabStatusInitialValue(() => {
                const newStatus = { ...tabStatusInitialValue };
                newStatus.tab2Status = { value: "Info", color: "red" };
                return newStatus;
              });
            }
          });
          handleShowFileError(response.data.data);
          setLoaderRunning(false);
          ref.current.complete();
            showToastv2(
              TOAST_TYPE.ERROR,
              action === ACTIONS.ADD
                ? "Error while creating user"
                : "Error while updating user"
            );
          
        }}catch(e){
          console.log("-- Exception --",e);
          setLoaderRunning(false);
          ref.current.complete();
          showToastv2(
            TOAST_TYPE.ERROR,
            action === ACTIONS.ADD
              ? "Error while creating user"
              : "Error while updating user"
          );
        }
      }
    },
  });

  useEffect(() => {
    checkForUserAccess();
  }, [roles[0],window.location.pathname]);


  // useEffect(() => {
  //   setInitialSelectedPediatricModalityId(values.selectedPediatricModalityId);
  // }, [values.selectedPediatricModalityId]);

  useEffect(()=>{
    console.log("---- Errors ---", errors);
  },[errors]);
  useEffect(() => {
    let newFirmIdList = checkFirm;
    setValues({ ...values, firmIdList: newFirmIdList });
  }, [values.firmIdList]);


  // useEffect(() => {
  //   setValues({ ...values, technicianContactList: technicianContactList });
  //   setTechnicianContactList(technicianContactList)
  //   console.log("Useeffect called with values : ", values);
  // }, [values.technicianContactList]);


  const handleAllFirmCheckboxClick = useCallback((e, isChecked) => {
    setCheckAllFirm(!checkAllFirm);
    setCheckFirm(firmList.map((firm) => firm.id));
    var modalityIdList = modalityList.map((mod) => mod.id);
    firmList
      .filter((firm) => !checkFirmNew.has(firm.id))
      .map((firm) => {
        setCheckFirmNew((prevMap) => {
          const nextMap = new Map(prevMap);
          nextMap.set(firm.id, modalityIdList);
          return nextMap;
        });
      });

    if (checkAllFirm) {
      setCheckFirm([]);
      setCheckFirmNew(new Map());
    }
    setTabStatusInitialValue(() => {
      const newStatus = { ...tabStatusInitialValue };
      newStatus.tab3Status =
        isChecked == true
          ? { value: "Completed", color: "green" }
          : { value: "Info", color: "red" };
      return newStatus;
    });
  });

  const handleModalitySelectionForFirm = useCallback((e, selection) => {
    if (selectedModalityForFirm.includes(selection)) {
      setSelectedModalityForFirm(
        selectedModalityForFirm.filter((mod) => mod != selection)
      );
    } else {
      setSelectedModalityForFirm([...selectedModalityForFirm, selection]);
      setTabStatusInitialValue(() => {
        const newStatus = { ...tabStatusInitialValue };
        newStatus.tab3Status = { value: "Completed", color: "green" };
        return newStatus;
      });
    }
  });

  // useEffect(() => {
  //   console.log("HII Modality selected");
  //   console.log(selectedModalityForFirm);
  // }, [selectedModalityForFirm]);

  const handleFirmCheckBoxClickNew = useCallback((e, isChecked, selection) => {
    if (checkFirmNew.has(e) && selection == 0) {
      //To handle deselection of firm
      setCheckFirmNew((prevMap) => {
        const nextMap = new Map(prevMap);
        nextMap.delete(e);
        return nextMap;
      });
      setCheckAllFirm(false);
    } else {
      // To handle Selection of firm
      var modalityIdList = modalityList.map((mod) => mod.id);
      if (selection != 0) {
        // To handle Modality selection
        modalityIdList = checkFirmNew.get(e);
        if (modalityIdList.indexOf(selection) > -1) {
          // To handle modality deselection
          modalityIdList = modalityIdList.filter((mod) => mod != selection);
        } else {
          modalityIdList.push(selection); //  To handle modality selection
        }
      }
      setCheckFirmNew((prevMap) => {
        const nextMap = new Map(prevMap);
        nextMap.set(e, modalityIdList);
        return nextMap;
      });
    }

    setTabStatusInitialValue(() => {
      const newStatus = { ...tabStatusInitialValue };
      if (isChecked == true) {
        newStatus.tab3Status = { value: "Completed", color: "green" };
      }
      return newStatus;
    });
  });

  const handleClearButton = useCallback((clientId) => {
    if (checkFirmNew.has(clientId)) {
      let modalityIdList = [];
      setCheckFirmNew((prevMap) => {
        const nextMap = new Map(prevMap);
        nextMap.set(clientId, modalityIdList);
        return nextMap;
      });
    }
  });

  const handleClearButtonForFirm = useCallback(() => {
    setSelectedModalityForFirm([]);
  });

  useEffect(() => {
    console.log("USE EFFECT --");
    console.log(checkFirmNew);
  }, [checkFirmNew]);

  const validateTabs = (tabNo) => {
    setSubmitClick(false);
    if (tabNo == 1) {
      setselectedTab(tabNo);
      setNextClicked(true);
      handleSubmit();
      // if ((values.mobile == null ||  values.mobile == "") || customMobileError != null && customMobileError != "") {
      //   console.log("---- Error ----");
      //   setTimeout(() => {
      //     setTabStatusInitialValue(() => {
      //       const newStatus = { ...tabStatusInitialValue };
      //       newStatus.tab1Status = { value: "Info", color: "red" };
      //       return newStatus;
      //     });
      //   }, 10);
      // }
      const mobileInvalid =
      !values.mobile || values.mobile === "" || (customMobileError && customMobileError !== "");

      // WhatsApp invalid when enabled AND either no value or Formik error or custom error
      const whatsappInvalid =
      values.enableWhatsApp &&
      isInvalidWhatsAppValue(values.whatsappNumber);


    const channelInvalid =
      (emailParentEnabled && !whatsappParentEnabled && !values.enableEmail) ||
      (whatsappParentEnabled && !emailParentEnabled && !values.enableWhatsApp) ||
      (emailParentEnabled && whatsappParentEnabled && !values.enableEmail && !values.enableWhatsApp);

    if (mobileInvalid || whatsappInvalid || channelInvalid) {
      setTabStatusInitialValue((prev) => {
        const newStatus = { ...prev };
        newStatus.tab1Status = { value: "Info", color: "red" };
        return newStatus;
      });
    }
    }
    if (tabNo == 2) {
      setselectedTab(tabNo);
      setNextClicked(true);
      handleSubmit();
    }
  };

  const handleSubmitCustom = () => {
    setSubmitClick(true);
    if (
      userType == USERTYPES.SUPERVISOR ||
      userType === USERTYPES.FIRMDOCTOR ||
      userType === USERTYPES.FIRMTECHNICIAN
    ) {
      if (
        userType == USERTYPES.SUPERVISOR &&
        selectedModalityForFirm.length === 0
      ) {
        setTabStatusInitialValue(() => {
          const newStatus = { ...tabStatusInitialValue };
          newStatus.tab3Status = { value: "Info", color: "red" };
          return newStatus;
        });
        setShowSelectModalityDialog(true);
        setNoSelectionErrorMessage(
          'Select atleast one modality for "' + firmName + '"'
        );
        return;
      }

      if (checkFirmNew.size > 0) {
        let allValuesAreNonEmpty = true;
        let noModalityFirmName = "";
        for (let [key, value] of checkFirmNew) {
          if (value.length === 0 || value.some((value) => value === "")) {
            allValuesAreNonEmpty = false;
            noModalityFirmName = firmList.find((obj) => obj.id === key).name;
            break;
          }
        }
        if (!allValuesAreNonEmpty) {
          console.log("No modality selected");
          setTabStatusInitialValue(() => {
            const newStatus = { ...tabStatusInitialValue };
            newStatus.tab3Status = { value: "Info", color: "red" };
            return newStatus;
          });
          setShowSelectModalityDialog(true);
          setNoSelectionErrorMessage(
            'Select atleast one modality for firm " ' + noModalityFirmName + '"'
          );
          return;
        }
      } else if (checkFirmNew.size == 0 && firmList.length > 0) {
        console.log("No firm selected");
        setTabStatusInitialValue(() => {
          const newStatus = { ...tabStatusInitialValue };
          newStatus.tab3Status = { value: "Info", color: "red" };
          return newStatus;
        });
        setShowCheckFirmDialog(true);
        setNoSelectionErrorMessage(t("user.select-atleast-one-firm"));
        return;
      }
    }

    if (userType == USERTYPES.RADIOLOGIST && roles[0] == USERTYPES.FIRMADMIN) {
      if (selectedModalityForFirm.length === 0) {
        setTabStatusInitialValue(() => {
          const newStatus = { ...tabStatusInitialValue };
          newStatus.tab3Status = { value: "Info", color: "red" };
          return newStatus;
        });
        setShowSelectModalityDialog(true);
        setNoSelectionErrorMessage(
          'Select atleast one modality for "' + firmName + '"'
        );
        return;
      }

      if (checkFirmNew.size > 0) {
        let allValuesAreNonEmpty = true;
        let noModalityFirmName = "";
        for (let [key, value] of checkFirmNew) {
          if (value.length === 0 || value.some((value) => value === "")) {
            allValuesAreNonEmpty = false;
            noModalityFirmName = firmList.find((obj) => obj.id === key).name;
            break;
          }
        }
        if (!allValuesAreNonEmpty) {
          console.log("No modality selected");
          setTabStatusInitialValue(() => {
            const newStatus = { ...tabStatusInitialValue };
            newStatus.tab3Status = { value: "Info", color: "red" };
            return newStatus;
          });
          setShowSelectModalityDialog(true);
          setNoSelectionErrorMessage(
            'Select atleast one modality for firm "' + noModalityFirmName + '"'
          );
          return;
        }
      }
    }
    if (userType == USERTYPES.RADIOLOGIST) {
      
      if (selectedModalityWithSubModality.length === 0) {
        // setTabStatusInitialValue(() => {
        //   const newStatus = { ...tabStatusInitialValue };
        //   newStatus.tab4Status = { value: "Info", color: "red" };
        //   return newStatus;
        // });
        setShowSelectModalityDialog(true);
        setNoSelectionErrorMessage(
          "Select atleast one auto assignment modality preference"
        );
        return;
      }
      if (values.pediatricSpecialist &&
        values.selectedPediatricModalityId.length === 0
      ) {
        // setTabStatusInitialValue(() => {
        //   const newStatus = { ...tabStatusInitialValue };
        //   newStatus.tab4Status = { value: "Info", color: "red" };
        //   return newStatus;
        // });
        setShowSelectModalityDialog(true);
        setNoSelectionErrorMessage(
          "Select atleast one pediatric modality preference"
        );
        return;
      }
    }
    handleSubmit();
  };

  useEffect(() => {
    const arrowElement = document.querySelector(
      ".react-tel-input .selected-flag .arrow"
    );
    if (arrowElement && getEnv("REACT_APP_HYBRID_MODE") != "false") {
      arrowElement.style.left = "10px";
    }
  }, []);

  const handleCancel = () => {
    if (action === ACTIONS.ADD) {
      navigate(-1);
    }
    if (action === ACTIONS.EDIT) {

      navigate(-1);
      setFetchDataToggle(!fetchDataToggle);
      setCheckFirmNew(new Map());
      setSelectedPediatricModalityId([]);
      setPediatricSpecialist(false);
      setAction(ACTIONS.VIEW)
      const forType = searchParams.get("for");
      if (forType === null || forType === undefined) {
        getBreadCrumbItems({ action: "VIEW" });
      }
    }
  };

  const handleEdit = () => {
    console.log("Hii from edit");
    const forType = searchParams.get("for");
    console.log(forType)
    console.log(userType)
    if (userType === USERTYPES.ADMIN || userType === USERTYPES.RADIOLOGIST) {
      navigate(AuthRoutes.MYEDITUSER + "?id=" + userData.user.id, {});
      setAction(ACTIONS.EDIT)
      getBreadCrumbItems({ action: "EDIT" });
    } else if (
      userType === USERTYPES.SUPERVISOR ||
      userType === USERTYPES.FIRMDOCTOR ||
      userType === USERTYPES.FIRMADMIN ||
      userType === USERTYPES.FIRMTECHNICIAN
    ) {
      
      if (forType === null || forType === undefined) {
        console.log("in if")
        navigate(
          AuthRoutes.MYEDITUSER +
            "?id=" +
            userData.user.id +
            "&firmId=" +
            searchParams.get("firmId"),
          {}
        );
        getBreadCrumbItems({ action: "EDIT" });
      } else {
        console.log("in else")
        navigate(
          AuthRoutes.MYEDITUSER +
            "?id=" +
            userData.user.id +
            "&firmId=" +
            searchParams.get("firmId") +
            "&for=" +
            forType,
          {}
        );
      }
      setAction(ACTIONS.EDIT)
    }else if (
      userType === USERTYPES.TYPIST
    ) {
      if (forType === null || forType === undefined) {
        console.log("in if")
        navigate(
          AuthRoutes.MYEDITUSER +
            "?id=" +
            userData.user.id +
            "&firmId=" +
            searchParams.get("firmId"),
          {}
        );
        getBreadCrumbItems({ action: "EDIT" });
      } else {
        console.log("in else")
        navigate(
          AuthRoutes.MYEDITUSER +
            "?id=" +
            userData.user.id +
            "&firmId=" +
            searchParams.get("firmId") +
            "&for=" +
            forType,
          {}//for what
        );
      }
      setAction(ACTIONS.EDIT)
    }
  };

  const setInitialErrors = () => {
    if (
      selectedTab == 1 &&
      nextClicked == true &&
      props.action != ACTIONS.VIEW
    ) {
      // existing checks...
        const hasBasicErrors =
          errors.firstName || errors.lastName || errors.email || errors.username || errors.password || errors.confirmPassword || errors.enableEmail;

        // new whatsapp check:
        const whatsappInvalid =
        values.enableWhatsApp &&
        isInvalidWhatsAppValue(values.whatsappNumber);


      //if (errors.firstName || errors.lastName || errors.email || errors.username || errors.password || errors.confirmPassword) {
  if (hasBasicErrors || whatsappInvalid) {
        setTabStatusInitialValue(() => {
          const newStatus = { ...tabStatusInitialValue };
          newStatus.tab1Status = { value: "Info", color: "red" };
          return newStatus;
        });
      } else if (!errors.firstName && !errors.lastName && !errors.email && !errors.username && !errors.password && !errors.confirmPassword && !errors.enableEmail) {
        setTabStatusInitialValue(() => {
          const newStatus = { ...tabStatusInitialValue };
          newStatus.tab1Status = { value: "Completed", color: "green" };
          return newStatus;
        });
      }
    }
    if (
      selectedTab == 2 &&
      nextClicked == true &&
      props.action != ACTIONS.VIEW
    ) {
      if (errors.signatureText || errors.capacity) {
        setTabStatusInitialValue(() => {
          const newStatus = { ...tabStatusInitialValue };
          newStatus.tab2Status = { value: "Info", color: "red" };
          return newStatus;
        });
      } else if (!errors.signatureText && !errors.capacity ) {
        setTabStatusInitialValue(() => {
          const newStatus = { ...tabStatusInitialValue };
          newStatus.tab2Status = { value: "Completed", color: "green" };
          return newStatus;
        });
      }
    }
  };

  useEffect(() => {
    setInitialErrors();
    console.log("VALUES in useEffect :", values);
  }, [errors, dirty, touched, values]);


  console.log("VALUES :", values);

  useEffect(() => {
    console.log("Parent useeffect", technicianContactList);
  }, [technicianContactList])


  const handleTabDetails = () => {
    let initialOrder = 1;
    let tabDetails = [
      {
        selectedKey: "1",
        tabName: `${t("user.user-details")}`,
        tabKeyContain: (
          <CustomTab
            orderNumber={initialOrder}
            tabName={t("user.user-details")}
            subtitle={t("sub-title.user.user-details")}
            iconName={tabStatusInitialValue.tab1Status.value}
            iconColor={tabStatusInitialValue.tab1Status.color}
          />
        ),
        tabValueContain: (
          <UserDetailsSection
            key="1"
            handleChange={handleChange}
            values={values}
            handleBlur={handleBlur}
            touched={touched}
            errors={errors}
            state={props}
            userType={userType}
            setCustomMobileError={setCustomMobileError}
            setFieldValue={setFieldValue}
            whatsappParentEnabled={whatsappParentEnabled}
            emailParentEnabled={emailParentEnabled}
            submitCount={submitCount}
          />
        ),
      },
    ];

    if (showTabTwo) {
      initialOrder++;
      tabDetails.push({
        selectedKey: initialOrder.toString(),
        tabName: `${t("user.settings")}`,
        tabKeyContain: (
          <CustomTab
            orderNumber={initialOrder}
            tabName={t("user.settings")}
            subtitle={t("sub-title.user.settings")}
            iconName={tabStatusInitialValue.tab2Status.value}
            iconColor={tabStatusInitialValue.tab2Status.color}
          />
        ),
        tabValueContain: (
          <SettingsSection
            key="2"
            values={values}
            state={props}
            userType={userType}
            handleChange={handleChange}
            handleBlur={handleBlur}
            errors={errors}
            touched={touched}
            expertRadiologist={expertRadiologist}
            setExpertRadiologist={setExpertRadiologist}
            radiologistSignatureImage={radiologistSignatureImage}
            modalityList={modalityList}
            handleClearRadiologistSignatureImage={handleClearRadiologistSignatureImage}
            isRadiologistSignatureImageDeleted={isRadiologistSignatureImageDeleted}
            setIsRadiologistSignatureImageDeleted={setIsRadiologistSignatureImageDeleted}
            setRadiologistImageFileName={setRadiologistImageFileName}
            radiologistImageFileName={radiologistImageFileName}
            setFieldValue={setFieldValue}
            userData={userData}
          />
        ),
      });
    }

    if (showTabThree) {
      initialOrder++;
      tabDetails.push({
        selectedKey: initialOrder.toString(),
        tabName: `${t("user.firm-access")}`,
        show: showTabThree,
        tabKeyContain: (
          <CustomTab
            orderNumber={initialOrder}
            tabName={t("user.firm-access")}
            subtitle={t("sub-title.user.firm-access")}
            iconName={tabStatusInitialValue.tab3Status.value}
            iconColor={tabStatusInitialValue.tab3Status.color}
          />
        ),
        tabValueContain: (
          <FirmAccessSection
            key="3"
            firmList={firmList}
            checkFirm={checkFirm}
            checkFirmNew={checkFirmNew}
            checkAllFirm={checkAllFirm}
            state={props}
            userType={userType}
            handleAllCheckboxClick={handleAllFirmCheckboxClick}
            handleCheckBoxClick={handleFirmCheckBoxClickNew}
            modalityList={modalityList}
            selectedModalityForFirm={selectedModalityForFirm}
            handleModalitySelectionForFirm={handleModalitySelectionForFirm}
            firmName={firmName}
            firmId={firmID}
            handleClearButton={handleClearButton}
            handleClearButtonForFirm={handleClearButtonForFirm}
          />
        ),
      });
    }

    if (showTabFour) {
      initialOrder++;
      tabDetails.push({
        selectedKey: initialOrder.toString(),
        tabName: `${t("user.assignment-preferences")}`,
        tabKeyContain: (
          <CustomTab
            orderNumber={initialOrder}
            tabName={t("user.assignment-preferences")}
            subtitle={t("sub-title.user.assignment-preferences")}
            iconName={tabStatusInitialValue.tab4Status.value}
            iconColor={tabStatusInitialValue.tab4Status.color}
          />
        ),
        tabValueContain: (
          (userType === USERTYPES.SUPERVISOR ? 
            <SupervisorAssignmentPreferences
            key="4"
            values={values}
            state={props}
            userType={userType}
            handleChange={handleChange}
            handleCancel={handleCancel}
            handleBlur={handleBlur}
            errors={errors}
            touched={touched}
            modalityList={modalityList}
            modalityWithSubModalityList={modalityWithSubModalityList}
            setSelectedModalityWithSubModality={
              setSelectedModalityWithSubModality
            }
            selectedModalityWithSubModality={selectedModalityWithSubModality}
            selectedModalitySubmodalityNames={selectedModalitySubmodalityNames}
          /> 
          : 
          <AssignmentPreferences
            key="4"
            values={values}
            state={props}
            userType={userType}
            handleChange={handleChange}
            handleCancel={handleCancel}
            handleBlur={handleBlur}
            errors={errors}
            touched={touched}
            modalityList={modalityList}
            modalityWithSubModalityList={modalityWithSubModalityList}
            selectedPediatricModalityId={selectedPediatricModalityId}
            setSelectedPediatricModalityId={setSelectedPediatricModalityId}
            pediatricSpecialist={pediatricSpecialist}
            setPediatricSpecialist={setPediatricSpecialist}
            setSelectedModalityWithSubModality={
              setSelectedModalityWithSubModality
            }
            selectedModalityWithSubModality={selectedModalityWithSubModality}
            selectedModalitySubmodalityNames={selectedModalitySubmodalityNames}
          />)
        ),
      });
    }
 
    if (showTabFive) {
      initialOrder++;
      tabDetails.push({
        selectedKey: initialOrder.toString(),
        tabName: `${t("user.assignment-preferences")}`,
        tabKeyContain: (
          <CustomTab
            orderNumber={initialOrder}
            tabName={t("user.contact-details")}
            subtitle={t("sub-title.user.contact-details")}
            // iconName={tabStatusInitialValue.tab4Status.value}
            // iconColor={tabStatusInitialValue.tab4Status.color}
          />
        ),
        tabValueContain: (
          <ContactDetailsSection key="5"
            handleChange={handleChange}
            values={values}
            setValues={setValues}
            handleBlur={handleBlur}
            setFieldValue={setFieldValue}
            validateForm={validateForm}
            touched={touched}
            errors={errors}
            state={props}
            userData={userData}
            userType={userType}
            customMobileError={customMobileError}
            setCustomMobileError={setCustomMobileError}
            technicianContactList={technicianContactList}
            setTechnicianContactList={setTechnicianContactList}
            submitCount={submitCount}
            />
        ),
      });
    }

    return tabDetails;
  };

  const topButtons = [
    {
      key: "1",
      button: (
        <PrimaryButton
          key="1"
          style={{ marginLeft: "10px" }}
          text={t("button.edit")}
          onClick={handleEdit}
        />
      ),
    },
  ];

  const tabValidation = (latestVal, previousVal) => {
    validateTabs(previousVal.charAt(previousVal.length - 1));
  };

  return (
    <>
      <div className="main-container-body">
        {/* <div style={{ height: !isMobile ? '92%' : '100%' }}> */}

        <TabContainer
          uniqueKey="user_"
          tabDetails={handleTabDetails()}
          NoOfTabs={totalTabs}
          onCancelClick={handleCancel}
          onSubmitClick={handleSubmitCustom}
          onNextClick={validateTabs}
          onEditClick={handleEdit}
          previousNextButton={true}
          state={props}
          action={props.action}
          mobileTabHeader="User Details"
          breadCrumbItems={breadCrumbItems}
          topButtons={props.action == ACTIONS.VIEW ? topButtons : []}
          tabValidation={tabValidation}
          updateActiveTab={updateActiveTab}
          setUpdateActiveTab={setUpdateActiveTab}
          userType={userType}
          values={values}
          currentUserRole={roles[0]}
        />
      </div>
      <DialogBox
        setShowDialogBox={
          showCheckFirmDialog
            ? setShowCheckFirmDialog
            : setShowSelectModalityDialog
        }
        showDialogBox={showCheckFirmDialog || showSelectModalityDialog}
        title={t("user.alert")}
        message={noSelectionErrorMessage}
        confirmButtonText={t("user.ok")}
        showOnlyOkButton={true}
      />
    </>
  );
};

export default MyAddUpdateUser;
